import { render } from "./404View.vue?vue&type=template&id=401bb2aa"
import script from "./404View.vue?vue&type=script&lang=js"
export * from "./404View.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__